import $ from 'jquery'
import globalEventBus from 'toxilibs/event_bus_queued.js'
import challengesNavigator from './challenges_navigator.js'
import getUrlParams from 'toxilibs/url_params.js'
import levelsLoader from './levels_loader.js'


const {isUrl} = levelsLoader


function loadChallenges (progressions) {
    let urlParams = getUrlParams()

    if ('progression' in urlParams && isUrl(urlParams.progression)) {
        loadProgressionUrl(urlParams.progression)
    } else {
        loadChallengesProgressions(progressions)
    }
}


function loadProgressionUrl (url) {
    $.ajax({
        url,
        type:     'GET',
        dataType: 'json',
        async:    true,
        success:  function (progressions) {
            loadChallengesProgressions(progressions)
        },
        error: function (data, errorType) {
            if (errorType === 'parsererror') {
                throw new Error('parse error in: ' + data.responseText)
            }
        }
    })
}


function loadChallengesProgressions (progressions) {
    const urlParams = getUrlParams()
    const challengesProgression = getChallengesProgression(progressions, urlParams)


    function whenLoaded (challenges) {
        setIdInChallenges(challenges, challengesProgression)
        challengesNavigator.add(challenges)


        if ('unlockAll' in urlParams) {
            challengesNavigator.unlockAll()
        }

        if ('resetAll' in urlParams) {
            challengesNavigator.reset()
        }

        globalEventBus.emit('application loaded')
        globalEventBus.emit('challenges added', challenges)
    }


    levelsLoader.loadLevels(challengesProgression)
        .then(whenLoaded)
        .catch((error) => console.error(error))

}


function getChallengesProgression (progressions, urlParams) {
    const specificFolder = urlParams.mode ? (urlParams.mode + '/') : '' //FIXME: for subfolder and id challenges

    const challengesProgression = challengesProgressionAccordingToParams(progressions, urlParams)

    for (let i = 0; i < challengesProgression.length; i++) {
        if (!isUrl(challengesProgression[i])) {
            challengesProgression[i] = 'challenges/' + specificFolder + challengesProgression[i]
        }
    }

    return challengesProgression
}


function challengesProgressionAccordingToParams (progressions, params) {
    if ('level' in params) {
        let specificChallenge = params.level
        return [specificChallenge]
    } else if ('progression' in params && isUrl(params.progression)) {
        return progressions
    } else {
        let progressionName   = params.progression || 'all'
        return progressions[progressionName] || progressions.all
    }
}


function setIdInChallenges (challenges, challengesPath) {
    for (let i = 0; i < challenges.length; i++) {
        let challengePath = challengesPath[i].split('/')
        challengePath = challengePath[challengePath.length - 1].split('.')[0]

        challenges[i].id = challengePath
    }
}


export default loadChallenges